<app-loader></app-loader>
<div *ngIf="userCommonService?.isMetadataLoaded" class="device-height">
  <app-header *ngIf="loadUI()" class="navbar"></app-header>
  <div class="main-panel container">
    <app-sidebar *ngIf="loadUI()" class="sidebar scroll-bar-css left-panel pl-2"></app-sidebar>
    <div class="right-panel scroll-bar-css overflowHide" id="rightPanel">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </div>
</div>
<app-message></app-message>